export const DISH_CATEGORIES = [
  { value: "staple", label: "主食" },
  { value: "meat", label: "荤菜" },
  { value: "seafood", label: "海鲜" },
  { value: "vegetable", label: "素菜" },
  { value: "soup", label: "汤锅" },
  { value: "snack", label: "小吃" },
  { value: "dessert", label: "甜品" },
] as const;

export type DishCategory = (typeof DISH_CATEGORIES)[number]["value"];

export interface Dish {
  id: number;
  name: string;
  category: DishCategory;
  imageUrl: string | null;
  createdAt: string;
}

export interface WheelResponse {
  slug: string;
  title: string;
  dishes: Dish[];
}

export interface CreateDishResponse {
  dish: Dish;
}

export interface ApiErrorResponse {
  code: string;
  message: string;
}
